
<div class="ContactSection" id="contact">
    <div class="SectionBackground">
        <div class="BackgroundPattern"></div>
    </div>

    <div class="ContactHeadline">
        <h2 class="MainHeadline">Fragen zu TaxiFusion?</h2>
        <p class="SubHeadline">
            Wir sind für Sie da und helfen Ihnen gerne bei allen Anliegen rund um TaxiFusion
        </p>
    </div>

    <div class="ContactContainer" v-if="hasSendMessage" ref="messageSend">
        <div class="SuccessMessage">
            <div class="SuccessIcon">
                <i class="ri-check-line"></i>
            </div>
            <h2>Ihre Nachricht wurde erfolgreich gesendet</h2>
            <p>
                Vielen Dank für Ihre Kontaktaufnahme! Wir werden uns schnellstmöglich bei Ihnen
                melden.
            </p>
            <div class="SuccessActions">
                <button @click="resetForm" class="ResetButton">
                    <i class="ri-mail-line"></i>
                    Neue Nachricht senden
                </button>
            </div>
        </div>
    </div>

    <div class="ContactContainer" v-else>
        <div class="ContactContent">
            <div class="ContactInfo">
                <div class="SectionHeader">
                    <h2>Wir freuen uns auf Ihre Nachricht</h2>
                    <p>
                        Haben Sie Fragen zu TaxiFusion? Unser Team steht Ihnen gerne zur
                        Verfügung.
                    </p>
                </div>

                <div class="ContactDetails">
                    <div class="ContactItem">
                        <div class="ContactItemIcon">
                            <i class="ri-mail-line"></i>
                        </div>
                        <div class="ContactItemContent">
                            <h3>E-Mail</h3>
                            <a href="mailto:support@taxifusion.de">support@taxifusion.de</a>
                        </div>
                    </div>

                    <div class="ContactItem">
                        <div class="ContactItemIcon">
                            <i class="ri-phone-line"></i>
                        </div>
                        <div class="ContactItemContent">
                            <h3>Telefon</h3>
                            <a href="tel:+4930959982020">030 959982020</a>
                        </div>
                    </div>

                    <div class="ContactItem">
                        <div class="ContactItemIcon">
                            <i class="ri-time-line"></i>
                        </div>
                        <div class="ContactItemContent">
                            <h3>Erreichbarkeit</h3>
                            <p>Montag - Freitag: 10:00 - 15:00 Uhr</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ContactFormWrapper">
                <form @submit.prevent="submitForm" class="ContactForm">
                    <div class="FormRow">
                        <div class="InputGroup">
                            <label for="name">Ihr Name</label>
                            <div class="InputWithIcon">
                                <i class="ri-user-line"></i>
                                <input
                                    type="text"
                                    id="name"
                                    v-model="form.name"
                                    placeholder="Vollständiger Name"
                                    required
                                />
                            </div>
                        </div>

                        <div class="InputGroup">
                            <label for="email">E-Mail Adresse</label>
                            <div class="InputWithIcon">
                                <i class="ri-mail-line"></i>
                                <input
                                    type="email"
                                    id="email"
                                    v-model="form.email"
                                    placeholder="name@beispiel.de"
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div class="InputGroup">
                        <label for="phone">Telefonnummer</label>
                        <div class="InputWithIcon">
                            <i class="ri-phone-line"></i>
                            <input
                                type="tel"
                                id="phone"
                                v-model="form.phone"
                                placeholder="+49 123 456789"
                            />
                        </div>
                    </div>

                    <div class="InputGroup">
                        <label for="message">Ihre Nachricht</label>
                        <div class="TextareaWrapper">
                            <textarea
                                id="message"
                                v-model="form.message"
                                placeholder="Wie können wir Ihnen helfen?"
                                required
                                @input="updateCharacterCount"
                            ></textarea>
                            <div
                                class="CharacterCounter"
                                :class="{ 'is-valid': characterCount >= minCharacterCount }"
                            >
                                <span>{{ characterCount }}/{{ minCharacterCount }}</span>
                                <div class="ProgressBar">
                                    <div
                                        class="Progress"
                                        :style="{
                                            width: `${Math.min(
                                                (characterCount / minCharacterCount) * 100,
                                                100,
                                            )}%`,
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Honeypot field for spam prevention -->
                    <input
                        type="text"
                        name="cat"
                        v-model="form.cat"
                        class="honeypot"
                        aria-hidden="true"
                    />

                    <div class="SubmitButtonWrapper">
                        <Button
                            type="submit"
                            class="SubmitButton"
                            size="large"
                            :isLoading="isSending"
                            :disabled="characterCount < minCharacterCount"
                            @onClick="handleSubmitAttempt"
                        >
                            Nachricht senden
                            <i class="ri-send-plane-line"></i>
                        </Button>

                        <div v-if="showValidationMessage" class="ValidationMessage">
                            <i class="ri-error-warning-line"></i>
                            Ihre Nachricht muss mindestens {{ minCharacterCount }} Zeichen lang
                            sein
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
